import {
    opensANewWindow,
    optOutFeedbackTitle,
    optOutEnterpriseFeedbackTitle,
    optOutFeedbackSubtitle,
    optOutEnterpriseFeedbackSubtitle,
    optOutFeedbackOk,
    optOutEnterpriseFeedbackOk,
    optOutFeedbackCancel,
    optOutEnterpriseFeedbackCancel,
} from './OptOutDialog.locstring.json';
import loc from 'owa-localize';
import { observer } from 'mobx-react';
/* tslint:disable:jsx-no-lambda WI:47720 */
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Dialog, DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { logUsage } from 'owa-analytics';
import { optIntoJsmvvmClientAndRedirect } from 'owa-optin';
import WebSessionType from 'owa-service/lib/contract/WebSessionType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

import * as React from 'react';
import * as ReactDOM from 'react-dom';

const styles = require('./OptOutDialog.scss');

export interface OptOutDialogProps {
    onCancel: () => void;
    modulePath: string;
    isConsumer: boolean;
}

export interface OptOutDialogState {
    isShown: boolean;
}

@observer
export class OptOutDialog extends React.Component<OptOutDialogProps, OptOutDialogState> {
    constructor(props: OptOutDialogProps) {
        super(props);
        this.state = {
            isShown: true,
        };
    }

    private onDismiss = () => {
        this.setState({
            isShown: false,
        });

        logUsage('OptOutCancel');

        this.props.onCancel();
    };

    private onShareThoughts = () => {
        logUsage('OptOutShareThoughts');
        const target = this.props.isConsumer
            ? 'https://outlook.uservoice.com/forums/601444-outlook-com-beta'
            : 'https://outlook.uservoice.com/forums/907141';
        window.open(target, '_blank');

        this.completeOptOut();
    };

    private onNotNow = () => {
        logUsage('OptOutNotNow');
        this.completeOptOut();
    };

    private completeOptOut = () => {
        this.setState({
            isShown: false,
        });

        optIntoJsmvvmClientAndRedirect(this.props.modulePath);
    };

    render() {
        const { isConsumer } = this.props;
        return (
            <Dialog
                hidden={!this.state.isShown}
                dialogContentProps={{
                    title: isConsumer
                        ? loc(optOutFeedbackTitle)
                        : loc(optOutEnterpriseFeedbackTitle),
                    subText: isConsumer
                        ? loc(optOutFeedbackSubtitle)
                        : loc(optOutEnterpriseFeedbackSubtitle),
                    type: DialogType.normal,
                }}
                modalProps={{
                    containerClassName: styles.optOutDialog,
                }}
                onDismiss={this.onDismiss}>
                <DialogFooter>
                    <PrimaryButton onClick={this.onShareThoughts} title={loc(opensANewWindow)}>
                        {isConsumer ? loc(optOutFeedbackOk) : loc(optOutEnterpriseFeedbackOk)}
                    </PrimaryButton>
                    <DefaultButton onClick={this.onNotNow}>
                        {isConsumer
                            ? loc(optOutFeedbackCancel)
                            : loc(optOutEnterpriseFeedbackCancel)}
                    </DefaultButton>
                    }
                </DialogFooter>
            </Dialog>
        );
    }
}

export default function showOptOutDialog(onCancel?: () => void, modulePath?: string) {
    // Show the opt out dialog
    // This had to be made distinct from owa-confirm-dialog because some pop up blockers (IE11)
    // didn't like the window.open call being outside of the button click handler.
    const optOutDialogDiv = document.createElement('div');
    optOutDialogDiv.id = 'optOutDialog';
    document.body.appendChild(optOutDialogDiv);

    const isConsumer =
        getUserConfiguration().SessionSettings.WebSessionType === WebSessionType.ExoConsumer;
    ReactDOM.render(
        <OptOutDialog
            onCancel={() => {
                ReactDOM.unmountComponentAtNode(optOutDialogDiv);
                document.body.removeChild(optOutDialogDiv);
            }}
            modulePath={modulePath}
            isConsumer={isConsumer}
        />,
        optOutDialogDiv
    );
}
